import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

// Whitelist de endereços de saque (camada de segurança / guardrails). Um endereço só é utilizável
// num saque depois de adicionado E validado (validar é passo explícito separado). A config do guard
// (kill-switch/dry-run/tetos) vive nas settings do usuário — ver SettingsService.
const ADDRESS_WHITELIST_URL = getBaseUrl('/addressWhitelist/');

export async function getAddressWhitelist() {
    return await appRequest.doGetRequest(ADDRESS_WHITELIST_URL);
}

export async function addWhitelistAddress(entry) {
    return await appRequest.doPostRequest(ADDRESS_WHITELIST_URL, entry);
}

export async function validateWhitelistAddress(id) {
    return await appRequest.doPostRequest(`${ADDRESS_WHITELIST_URL}${id}/validate`, {});
}

export async function deleteWhitelistAddress(id) {
    return await appRequest.doDeleteRequest(`${ADDRESS_WHITELIST_URL}${id}`);
}
